import { Button } from './button';
import { Input } from './input';

export const forms = {
  Button,
  Input,
};
